import React, { useState, useEffect } from 'react'
import { useParams, useLocation } from 'react-router-dom'
import { useEntityNavigate as useNavigate } from '../../navigation/navigation'
import api from '../../services/api'
import EntityForm from '../../components/EntityForm'
import { Button } from '../../components/ui'
import { getSafeReturnTarget } from '../../utils/returnNavigation'
import './Company.css'

function ActEdit() {
  const { contractId: contractIdParam, id } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const isNew = location.pathname.endsWith('/new') || id === 'new'
  const editId = isNew ? null : id
  const returnTarget = getSafeReturnTarget(location.state)

  const [contractId, setContractId] = useState(contractIdParam)
  const [loadingContext, setLoadingContext] = useState(!contractIdParam && !!editId)
  const isGenericActEdit = !isNew && !contractIdParam && !!editId

  useEffect(() => {
    if (contractIdParam || !editId) return
    let cancelled = false
    async function loadAct() {
      try {
        const res = await api.get(`/company/acts/${editId}`)
        const act = res.data?.act
        if (act?.contract_id && !cancelled) {
          setContractId(act.contract_id)
        }
      } catch (err) {
        console.error('Error loading act for context:', err)
      } finally {
        if (!cancelled) setLoadingContext(false)
      }
    }
    loadAct()
    return () => { cancelled = true }
  }, [contractIdParam, editId])

  const handleBack = () => {
    if (returnTarget.returnTo) {
      navigate(returnTarget.returnTo)
    } else if (isGenericActEdit) {
      navigate(`/act/${editId}`)
    } else if (contractId) {
      navigate(`/contract/${contractId}`)
    } else {
      navigate(-1)
    }
  }

  const backLabel =
    returnTarget.returnLabel ||
    (isGenericActEdit ? '← Назад к акту' : (contractId ? '← Назад к договору' : '← Назад'))

  if (loadingContext) {
    return (
      <div className="company-page">
        <div className="loading">Загрузка...</div>
      </div>
    )
  }

  return (
    <div className="company-page">
      <div className="page-header">
        <Button variant="ghost" onClick={handleBack} className="btn-back">
          {backLabel}
        </Button>
      </div>
      <EntityForm
        entityType="acts"
        entityId={editId}
        context={{ contractId: contractId || contractIdParam, legacyStageId: isNew ? location.state?.legacyStageId : undefined }}
        title={isNew ? 'Новый акт' : 'Редактирование акта'}
      />
    </div>
  )
}

export default ActEdit
